var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverdueTickets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49967 2.5C1.57467 2.5 0.833008 3.24167 0.833008 4.16667V15.8333C0.833008 16.2754 1.0086 16.6993 1.32116 17.0118C1.63372 17.3244 2.05765 17.5 2.49967 17.5H14.1663C15.0913 17.5 15.833 16.7583 15.833 15.8333V7.5L10.833 2.5H2.49967ZM14.1663 15.8333H2.49967V4.16667H8.33301V10H14.1663V15.8333ZM9.99967 8.33333V3.75L14.583 8.33333H9.99967ZM19.1663 5.83333V10.8333H17.4997V5.83333H19.1663ZM17.4997 12.5H19.1663V14.1667H17.4997V12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdueTickets);
export default __webpack_public_path__ + "static/media/overdueTickets.82840d78c136d8720ba9a940bad2d097.svg";
export { ForwardRef as ReactComponent };